<template>
  <div>
    <HeaderGestion/>
    <SubHeader
      nombre="Búsquedas"
      precedente="Hola"
      color= "2"
    />
    <FormBusquedas/>
  </div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeader from '../components/SubHeader.vue'
import FormBusquedas from '../components/FormBusquedas.vue'
export default {
  components: { HeaderGestion, SubHeader, FormBusquedas },
  name: 'Busquedas'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
